import '../../styles/tag.scss';

import { ReactNode } from 'react';

export type TagColor =
  | 'blue'
  | 'green'
  | 'grey'
  | 'orange'
  | 'magenta'
  | 'purple'
  | 'red'
  | 'teal'
  | 'yellow'
  | undefined;

export interface TagProps {
  color?: TagColor;
  className?: string;
  children?: ReactNode;
}

export default function Tag({ color, className = '', children }: TagProps) {
  const colorClass = color ? `govuk-tag--${color}` : '';
  return <strong className={`govuk-tag ${colorClass} ${className}`}>{children}</strong>;
}
